import(/* webpackMode: "eager", webpackExports: ["default"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/app/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/components/common/Dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/components/layout/ConditionalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/frontend/src/contexts/ToastContext.tsx");
